import { Component} from '@angular/core';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import Swal from "sweetalert2";
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { FileCloudService } from '../../../services/configuracion/fileCloud/file-cloud.service';
import { DomSanitizer } from '@angular/platform-browser';

export interface Image{
  "name": string,
  "content": string
}

declare var $: any;
@Component({
  selector: 'app-conf-inversores',
  templateUrl: './conf-inversores.component.html',
  styleUrls: ['./conf-inversores.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})

export class ConfInversoresComponent{

  Contacto: any;
  loading: boolean = false;
  razSocial: string;
  formContacto : FormGroup;
  formBody : FormGroup;
  items: any;
  images: Image[] = []; 
  rucEmpresa: string = "";
  flgView: boolean = false;

  constructor(
    private loginService:LoginService,
    private empresasService:EmpresasService,
    private fileCloudService:FileCloudService,
    private domSanitizer: DomSanitizer,
    private router :Router
  ){

    this.formBody = new FormGroup({
      id_empresa: new FormControl('',  Validators.required),
      usuario :new FormControl('',  Validators.required),
      ruc :new FormControl('',  Validators.required),
      NombreProyecto :new FormControl('CrowdFactoring',  Validators.required)
    });


    this.razSocial = sessionStorage.getItem('razSocial');
    this.Contacto = this.empresasService.datos;
    this.rucEmpresa = this.Contacto.rucEmpresa;

    if(this.Contacto.Adjunto_DNI == null) {this.Contacto.Adjunto_DNI = ""}

    if(this.Contacto.Adjunto_DNI.length !== 0){
      
      const links = this.Contacto.Adjunto_DNI.split("|", 2); 
      let cont = 0;
      links.forEach(element =>{

        let link = element.split("https://drive.google.com/open?id=").pop(); 

        let nombres = ["Fotografía Nro 1","Fotografía Nro 2"];

        this.fileCloudService.downloadFile(link).subscribe(
          res =>{
            let file: any = res;
                if(file.error === undefined){
                  this.images.push({name: nombres[cont], content: "data:image/jpeg;base64,"+file.body});
                } else {
                  this.showNotification('danger','top','right','Error al intentar obtener '+nombres[cont]+' del contacto.');
                }
                cont++;
          },err =>{
            cont++;
            this.showNotification('danger','top','right','Error al intentar obtener fotografías del contacto.');
          });
        })
    } else {
        this.showNotification('warning','top','right','Contacto no cuenta con imágenes anexadas.');
    }
      this.formContacto = new FormGroup({
        NroContacto: new FormControl({value:this.Contacto.idContacto, disabled: true}),
        Nombres :new FormControl({value:this.Contacto.Nombre_de_Contacto, disabled: true}),

        NroDocumento :new FormControl({value:this.Contacto.Nro_Documento_Identidad, disabled: true}),
        Estado :new FormControl({value:this.Contacto.Des_Estado, disabled: true}),

        Tipo :new FormControl({value:this.Contacto.Des_Tipo_de_Contacto, disabled: true}),

        Celular :new FormControl({value:this.Contacto.NroMovil_Laboral, disabled: true}),
        Telefono :new FormControl({value:this.Contacto.NroFijo_Laboral, disabled: true}),

        Correo : new FormControl({value:this.Contacto.Correo, disabled: true}),
      });    
  }

  verificarUsuario(){
    this.formBody.controls['id_empresa'].setValue('1');
    this.formBody.controls['usuario'].setValue(this.Contacto.Nro_Documento_Identidad);
    this.formBody.controls['ruc'].setValue(this.rucEmpresa);

    Swal.fire({
      title: 'Atención',
      text: "¿Deseas aprobar al contacto?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Aceptar',
      cancelButtonColor: '#d33',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        })
        Swal.showLoading();
        this.loginService.generarCodigoActivacion(this.formBody.getRawValue()).subscribe(
          res =>{
            Swal.fire({
              title: "¡Éxito!",
              text: 'El usuario ha sido notificado satisfactoriamente',
              type: "success",
              heightAuto: false
            });
          },err => {
            Swal.fire({
              title: "Error",
              text: 'Error al intentar notificar al usuario.',
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );  
      }
    })    
  }

  retornarListado(){
    this.loginService.clickGuard = true;
    let id = this.Contacto.idEmpresa;
    this.router.navigate(['/empresas/inversor/contactos/',id]);
  }

  viewImage(position){
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.images[position].content);
  }

  viewPhotographys(){
    if(this.images.length > 0){
      this.flgView = !this.flgView;
    } else {
      this.showNotification('warning','top','right','No existen fotografías para mostrar.');
    }
  }

  showNotification(type,from,align,message){
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}
